<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>{{ $t('Banner.Edit.header') }}</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field switchbox">
                            <label for="type">{{ $t('Banner.Edit.Active') }}</label>
                            <!-- <Dropdown v-model="dropdownValueType" :options="dropdownValueTypes" optionLabel="name" :placeholder="type" /> -->
                            <div class="switch">
                                <InputSwitch v-model="status" trueValue="active" @change="switchValue(id, status)" />
                            </div>
                            <!-- <div class="text-red">{{ error.type }}</div> -->
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-5 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Banner.list.title') }}</label>
                            <InputText type="text" :placeholder="$t('Banner.list.title')" id="title2" v-model="title" @keydown.space="preventLeadingSpace"></InputText>
                            <div class="text-red">{{ error.title }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-5 p-mb-lg-0 p-field">
                            <label for="subtitle2">
                                {{ $t('Banner.list.deskbanner') }}
                            </label>
                            <!-- file upload field  -->
                            <div :class="`${error.file ? 'custom-select-invalid' : 'custom-select'}`">
                                <!-- <span v-if="old_file && !fileName">{{ old_file }}</span> -->
                                <!-- <span v-if="!image_url">파일 선택</span>
                                <span v-else>{{ image_url }}</span> -->
                                <span v-if="!fileName">파일 선택</span>
                                <span v-else>{{ fileName }}</span>
                                <input type="file" class="select-file" v-on:change="onFileChange" />
                                <Button :label="$t('Banner.Edit.select_file')" class="SelectBtn n-wrap" />
                            </div>

                            <span class="img-info">{{ $t('Banner.Edit.File') }}</span
                            ><br />
                            <div class="text-red" v-show="render5">{{ render5Value }}</div>
                            <div class="text-red" v-show="render1">{{ $t('validation.invalidFile') }}</div>
                            <!-- add larger image  -->
                            <div class="text-red" v-show="render2">작은 이미지에 더 큰 이미지를 추가하십시오</div>
                            <!-- file is too large  -->
                            <div class="text-red" v-show="render3">파일이 너무 큽니다</div>
                            <div class="text-red" v-show="render4">{{ render4Value }}</div>

                            <!-- display image  -->
                            <div style="display: -webkit-box; justify-content: flex-end" v-if="image_url">
                                <div class="raw-image" style="margin: 5px">
                                    <Image :src="image_url" :alt="file" class="product-image" width="137" height="85" preview />
                                    <div>
                                        <img @click="remove_banner_image($route.params.id)" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/96/000000/external-cross-essentials-tanah-basah-glyph-tanah-basah.png" class="cross" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-5 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Banner.Edit.url') }}</label>
                            <InputText type="text" placeholder="URL" id="title2" v-model="redirection_url" @keydown.space="preventLeadingSpace"></InputText>
                            <div class="text-red">{{ error.redirection_url }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <!-- right end button  -->
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right; margin-top: -30px">
                <Button :label="$t('Banner.Edit.Back')" class="p-button p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)" id="back" icon="pi pi-replay" iconPos="left"></Button>
            </div>
            <!-- left end button  -->
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left; margin-top: -30px">
                <ConfirmPopup group="popup"></ConfirmPopup>
                <Button :disabled="btnDisabled" :label="$t('Banner.list.save')" class="p-button p-button p-mr-2 p-mb-2" @click="confirm($event)" id="save" icon="pi pi-check" iconPos="left"></Button>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import validateCreateBanner from '../../validations/banner/validateCreateBanner';
import BannerService from '../../service/API/BannerService';
export default {
    name: 'EditNft',
    data() {
        return {
            btnDisabled: false,
            render1: false,
            render2: false,
            render3: false,
            render4: false,
            render5: false,
            render4Value: '',
            render5Value: '',
            dropdownValues: [
                { name: 'active', code: '활성' },
                { name: 'inactive', code: '비활성' },
            ],
            dropdownValueTypes: [{ name: 'nft' }, { name: 'card_news' }, { name: 'media_press' }, { name: 'de_fi_services' }],
            dropdownValue: null,
            dropdownValueType: null,
            title: '',
            link: '',
            files: '',
            filesName: '',
            file: '',
            image_url: '',
            redirection_url: '',
            fileName: '',
            fileExtension: '',
            filesExtension: '',
            //   formData: {
            //     title : '',
            //     banner_id: null,
            //     status : '',
            //     image: ''
            //   },
            formData: new FormData(),
            error: {},
            status: '',
            fileName1: '',
            fileName2: '',
            type: null,
            old_file: '',
            display: false,
            crossdisplay3: true,
            id: '',
            image: {
                sizeExcet: false,
                path: '',
                name: '',
                binary: null,
            },
            isValid: false,
        };
    },
    created() {
        this.bannerService = new BannerService();
    },
    mounted() {
        this.bannerService.viewBanner(this.$route.params.id).then((result) => {
            this.title = result.title;
            this.status = result.status;
            this.image_url = result.image_url ? result.image_url : '';
            // this.old_file = result.image_url;
            this.redirection_url = result.redirection_url;
            // this.file = result.image_url;
            //   console.log(result);
        });
    },
    watch: {
        imageUrl(image_url) {
            if (image_url === '' || !image_url) {
                this.render5Value = `파일을 업로드 해주세요`;
                this.render5 = true;
                this.btnDisabled = true;
            } else {
                this.render5Value = '';
                this.btnDisabled = false;
                this.render5 = false;
            }
            // This function will be called whenever the imageUrl changes
            console.log('New image URL:', image_url);
        },
    },

    methods: {
        
        myUploader(event) {
            //event.files == files to upload
            console.log('test success', event.files[0]);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        reinitialize() {
            (this.dropdownValue = null), (this.dropdownValueType = null), (this.title = null), (this.subtitle = null), (this.link = null), (this.fileName = null), (this.file = {});
        },
        switchValue(id, switchstatus) {
            // console.log(id, switchstatus);
            var self = this;
            axios({ method: 'post', url: '/api/v1/admin/banner/status-update', data: { banner_id: this.$route.params.id, status: switchstatus === false ? 'deleted' : 'active' } }).then(function (response) {
                if (response.data.message === 'lastrecord') {
                    // self.$router.push({ name: 'EditBanner' });
                    setTimeout(() => {
                        self.$toast.add({ severity: 'error', summary: '오류가 발생했습니다.', detail: '최소 1개의 배너는 활성화 되어야 합니다.', life: 3000 });
                        // self.$router.push({ name: 'EditBanner' });
                        // this.trueValue = true;
                        window.location.reload();
                    }, 500);
                    // self.trueValue = active;
                } else {
                    // this.$router.push({ name: 'Banner Management' });
                    self.$toast.add({ severity: 'info', summary: '확인.', detail: '배너 상태가 성공적으로 업데이트되었습니다.', life: 3000 });
                    console.log(response);
                }
            });
        },
        preventLeadingSpace(e) {
            // only prevent the keypress if the value is blank
            if (!e.target.value) e.preventDefault();
            // otherwise, if the leading character is a space, remove all leading white-space
            else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, '');
        },

        onFileChange(e) {
            // if (!files) {
            //     this.render5 = true;
            //     this.btnDisabled = true
            //     return;
            // }
            var files = e.target.files || e.dataTransfer.files;
            // if (!files.length) return;
            this.file = files[0];
            var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!allowedExtensions.exec(this.file.name)) {
                this.render1 = true;
                this.render2 = false;
                this.render4 = false;
                this.btnDisabled = true;
            } else {
                let reader = new FileReader();
                reader.readAsDataURL(this.file);
                reader.onload = (e) => {
                    let url = e.target.result;
                    this.image_url = url;
                };
                this.render1 = false;
                if (this.file.size > 26214400) {
                    // alert('파일이 너무 큽니다  ');
                    this.render1 = false;
                    this.render2 = true;
                } else {
                    this.render1 = false;
                    this.render2 = false;
                    this.fileName = this.file.name;
                    this.upload(e);
                }
            }
            this.fileExtension = this.fileName.replace(/^.*\./, '');
        },
        upload(e) {
            var files = e.target.files || e.dataTransfer.files;
            var img = new Image();
            img.src = window.URL.createObjectURL(e.target.files[0]);
            img.onload = () => {
                if (img.width > 343 || img.height > 138) {
                    this.btnDisabled = true;
                    this.render4Value = `343px x 138px 사이즈의 이미지를 업로드 해주세요.`;
                    this.render4 = true;
                    this.render1 = false;
                    //   alert(`Sorry, this image doesn't look like the size we wanted.It's
                    //     ${img.width} x ${img.height} but we require 343 x 138 size image.`);
                } else {
                    this.btnDisabled = false;
                    this.render4 = false;
                    this.fileName = this.file.name;
                    this.formData.append('image', files[0]);
                    this.render1 = false;
                }
            };
        },

        remove_banner_image(id) {
            if (confirm('정말 삭제하시겠습니까?')) {
                this.image_url = '';
                this.btnDisabled = true;
                axios({ method: 'get', url: `api/v1/admin/banner/delete/${id}` })
                    .then(function () {
                        //   console.log(response);
                    })
                    .catch((error) => {
                        return error;
                    });
            }
        },
        confirm(event) {
            var self = this;
            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '이대로 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    let vcheckData = {
                        title: this.title,
                        status: this.status ? 'active' : 'deleted',
                        file: this.image == '' ? '' : 'something',
                        redirection_url: this.redirection_url,
                    };
                    const { isInvalid, error } = validateCreateBanner(vcheckData);
                    if (isInvalid) {
                        self.error = error;
                        self.render1 = false;

                        //   console.log(error);
                    } else {
                        this.btnDisabled = false;
                        self.error = '';
                        self.render1 = false;
                        this.formData.append('title', this.title);
                        this.formData.append('banner_id', this.$route.params.id);
                        this.formData.append('status', this.status === undefined ? (this.status == '활성' ? 'active' : 'deleted') : this.status);
                        this.formData.append('redirection_url', this.redirection_url);
                        // this.formData.append('type', this.dropdownValueType?.name === undefined ? this.type : this.dropdownValueType?.name);
                        //   console.log(this.formData);
                        return axios.post('/api/v1/admin/banner/edit', this.formData).then(() => {
                            this.$router.push({ name: 'Banner Management' });
                            setTimeout(() => {
                                self.$toast.add({ severity: 'success', summary: '확인.', detail: '배너가 성공적으로 업데이트되었습니다.', life: 3000 });
                            }, 500);

                            //   console.log(res);
                        });
                    }
                },
                reject: () => {
                    //   self.$toast.add({ severity: 'error', summary: '오류가 발생했습니다.', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style scoped>
.img-info {
    font-size: 11px;
    font-weight: 400;
    color: rgb(48, 48, 48);
}

.product-image {
    padding-top: 5px;
    border: 0px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: 150px !important;
    height: 100px;
    float: left;
}

.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}

.SelectBtn {
    max-width: 100px;
}

.custom-select span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.custom-select-invalid {
    position: relative;
    border: 1px solid red;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.p-col-12.p-mb-2.p-lg-3.p-mb-lg-0.p-field.switchbox {
    display: flex;
    margin-left: 0px;
}

.switch {
    margin-left: 10px;
}

button#back {
    border: 1px solid black;
    color: black;
}

button#save {
    background: black;
    border: 1px solid black;
}

.cross {
    position: absolute;
    right: 15px;
    top: 15px;
    z-index: 2;
    height: 20px;
    width: 20px;
    background-color: white;
}

.raw-image {
    position: relative;
}
.card {
    height: 100%;
}
</style>
